import { useApolloClient } from '@apollo/client';

import {
  CollaborativeDocumentFragmentDoc,
  useCollaborativeDocumentUpdatedSubscription,
} from '@spotify/confidence-graphql';

type CollaborativeDocumentUpdatesOptions = {
  skip?: boolean;
};

export const useCollaborativeDocumentUpdates = ({
  skip = false,
}: CollaborativeDocumentUpdatesOptions = {}) => {
  const client = useApolloClient();

  useCollaborativeDocumentUpdatedSubscription({
    skip,
    onData: ({ data: result }) => {
      const document =
        result.data?.collaborativeDocumentUpdated?.collaborativeDocument;
      if (!document?.__typename || !document.name) return;

      client.cache.writeFragment({
        id: client.cache.identify(document),
        fragment: CollaborativeDocumentFragmentDoc,
        fragmentName: 'CollaborativeDocument',
        data: document,
      });
    },
  });
};
